import createIcon from '../../createIcon';

/**
 * @component @name FitnessCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNTcgMTQuODZMMjIgMTMuNDNMMjAuNTcgMTJMMTcgMTUuNTdMOC40MyA3TDEyIDMuNDNMMTAuNTcgMkw5LjE0IDMuNDNMNy43MSAyTDUuNTcgNC4xNEw0LjE0IDIuNzFMMi43MSA0LjE0TDQuMTQgNS41N0wyIDcuNzFMMy40MyA5LjE0TDIgMTAuNTdMMy40MyAxMkw3IDguNDNMMTUuNTcgMTdMMTIgMjAuNTdMMTMuNDMgMjJMMTQuODYgMjAuNTdMMTYuMjkgMjJMMTguNDMgMTkuODZMMTkuODYgMjEuMjlMMjEuMjkgMTkuODZMMTkuODYgMTguNDNMMjIgMTYuMjlMMjAuNTcgMTQuODZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FitnessCenter = createIcon('FitnessCenter', [
  [
    'path',
    {
      d: 'M20.57 14.86L22 13.43L20.57 12L17 15.57L8.43 7L12 3.43L10.57 2L9.14 3.43L7.71 2L5.57 4.14L4.14 2.71L2.71 4.14L4.14 5.57L2 7.71L3.43 9.14L2 10.57L3.43 12L7 8.43L15.57 17L12 20.57L13.43 22L14.86 20.57L16.29 22L18.43 19.86L19.86 21.29L21.29 19.86L19.86 18.43L22 16.29L20.57 14.86Z',
      key: 'wldioo',
    },
  ],
]);

export default FitnessCenter;
